import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { fetchProjets } from '../../api/projetApi';

const ListeProjets = () => {
  const [projets, setProjets] = useState([]);

  useEffect(() => {
    const loadProjets = async () => {
      const data = await fetchProjets();
      setProjets(data);
    };
    loadProjets();
  }, []);

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'nom', headerName: 'Nom', width: 200 },
    { field: 'description', headerName: 'Description', width: 300 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      renderCell: (params) => (
        <>
          <Button
            component={Link}
            to={`/projets/${params.row.id}`}
            variant="contained"
            color="primary"
            size="small"
          >
            Détails
          </Button>
          <Button
            component={Link}
            to={`/projets/edit/${params.row.id}`}
            variant="outlined"
            color="secondary"
            size="small"
            sx={{ ml: 1 }}
          >
            Modifier
          </Button>
        </>
      ),
    },
  ];

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={projets}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
      />
      <Button
        component={Link}
        to="/projets/new"
        variant="contained"
        color="success"
        sx={{ mt: 2 }}
      >
        Nouveau Projet
      </Button>
    </Box>
  );
};

export default ListeProjets;
